<div class="dialog-container">
  <div class="dialog-title-wrapper">
    <h2 class="dialog-title" mat-dialog-title>
      {{'table.filter_title' | translate : {value: data.title ?? '' | translate | lowercase } }}
    </h2>
    <p *ngIf="data.description" class="dialog-subtitle">{{data.description}}</p>
  </div>
  <div mat-dialog-content cdkScrollable>
    <form [formGroup]="filterFormControl">
      <div *ngFor="let col of filterDialogSelectionData; let last = last" class="filter_dialog_form">
          <valg-input-group [legend]="(col.column.metadata?.filter?.filterColumnName ?? col.column.title)">
            <valg-checkbox-group *ngIf="col.filterType == FilterType.checkbox"
                    [formControlName]="col.column.title"
                    [collection]="col.value"
                    [twoColumnsOptionsDefaultLength]="4"
            ></valg-checkbox-group>
            <label *ngIf="col.filterType != FilterType.checkbox"
                    valgLabel>{{(col.column.metadata?.filter?.filterColumnName ?? col.column.title) | translate}}</label>
            <input *ngIf="col.filterType == FilterType.string"
                   [placeholder]="'standard_input.filter.placeholder' | translate: { filterName : ((col.column.metadata?.filter?.filterColumnName?.toLowerCase() ?? col.column.title.toLowerCase()) | translate).toLowerCase() }"
                   [formControlName]="col.column.title"
                   valgInput
            />
            <input *ngIf="col.filterType == FilterType.postalcode"
            [placeholder]="'standard_input.filter.placeholder' | translate: { filterName : ((col.column.metadata?.filter?.filterColumnName?.toLowerCase() ?? col.column.title.toLowerCase()) | translate).toLowerCase() }"
            [formControlName]="col.column.title"
            valgPostalCodeInput
            />
            <valg-datepicker *ngIf="col.filterType == FilterType.date">
              <input
                      [formControlName]="col.column.title"
                      [placeholder]="'standard_input.date_input.placeholder' | translate"
                      valgInput
              /></valg-datepicker>
        </valg-input-group>
        <hr *ngIf="!last && col.filterType == FilterType.checkbox">
      </div>
    </form>
  </div>
</div>

<div class="dialog-footer">
  <button 
    (click)="onFilterClicked()" 
    color="primary" 
    valgButton>
    {{
      data.buttonTitle
        ? data.buttonTitle 
        : ('table.filter_save' | translate)
    }}
  </button>
  <button (click)="onNoClick()" color="text-only" valgButton>
    {{'table.filter_cancel' | translate}}
  </button>
</div>
